<template>
    <div class="p-grid p-fluid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Espelho</h5>
                <hr />
                <div class="p-fluid p-formgrid p-grid">                          
                    <div class="p-field p-col-12">
                        <label>Período</label>
                        <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :manualInput="false" 
                            :showIcon="true" :yearNavigator="true" 
                            :yearRange="rangeData" :locale="localeCalendarBR" @date-select="getEspelho"/> 
                    </div>
                </div>   
                <Accordion>
                    <AccordionTab v-for="ponto in pontos" :key="ponto.id">
                        <template #header>                       
                            <span :class="ponto.irregular ? 'ik-text-danger' : ''">{{ formatarData(ponto.dia) }}</span> &nbsp;
                            <i class="pi pi-clock" v-for="marcacao in ponto.marcacoes" :title="formatarDataHora(marcacao)">&nbsp;</i>
                        </template>
                        <p v-if="ponto.marcacoes.length > 0">
                            <i class="pi pi-clock"></i><label class="p-ml-2">Marcações</label>
                            <div v-for="marcacao in ponto.marcacoes">
                                <label class="ik-text-success p-text-bold">{{ formatarDataHora(marcacao) }}</label> 
                            </div>                        
                        </p>
                        <p v-if="ponto.horasFaltantes">
                            <i class="pi pi-minus-circle"></i><label class="p-ml-2">Horas Faltantes</label>
                            <div><label class="p-text-bold ik-text-danger">-{{ ponto.horasFaltantes }}</label></div>
                        </p>
                        <p v-if="ponto.divergencias.length > 0">
                            <i class="pi pi-thumbs-down"></i> <label class="p-ml-2">Ocorrências</label>
                            <div v-for="diverg in ponto.divergencias">
                                <label class="p-text-bold ik-text-danger">{{ diverg.descricao }}</label>
                            </div>                        
                        </p>
                        <p v-if="ponto.observacao">
                            <i class="pi pi-info-circle"></i><label class="p-ml-2 p-text-bold">Observação</label>
                            <div><label>{{ ponto.observacao }}</label></div>
                        </p>                                   
                        <Button label="Justificar Ponto" icon="pi pi-check" 
                            class="p-button-primary p-mr-2 p-mb-2" style="width: 160px;"                           
                            v-if="temJustificarPonto && ponto.divergencias.length > 0"
                            @click="exibirJustificarPonto(ponto)"/>
                        <Button label="Incluir Marcação" icon="pi pi-clock" 
                            class="p-button-primary" style="width: 160px;" 
                            v-if="temIncluirMarcacao"
                            @click="exibirIncluirMarcacao(ponto)"/>                   
                    </AccordionTab>
                </Accordion>             
            </div> 
        </div>
        <SolicitacaoCelular ref="formIncluirSolicitacao"/>       
    </div>
</template>
  
<script>
import SolicitacaoCelular from '@/components/pages/espelho/SolicitacaoCelular.vue';
import PontoService from '@/service/PontoService';
import { mapGetters, mapActions } from 'vuex';
import { exibirMensagem, localeCalendarBR} from '@/global';
  
export default {
    pontoService: null,
    data() {
        return {
            localeCalendarBR: localeCalendarBR,
            mesAno: new Date(),          
            rangeData: '',      
            justificativasGerais:[],
            justificativasMarcacoes: [],
            temJustificarPonto: false,
            temIncluirMarcacao: false,   
            pontos: []
        }
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario']),
        ...mapActions('sessao', ['limparSessao']),        
        /**
         * 
         */
        getEspelho() {            
            let hoje = new Date();
            if(hoje.getFullYear() == this.mesAno.getFullYear() 
                && hoje.getMonth() == this.mesAno.getMonth()) {
                this.mesAno = hoje;
            }
            let requisicao = {
                id: this.getUsuario().id,
                grupo: this.getUsuario().grupo,
                mes: this.mesAno.getMonth() + 1,
                ano: this.mesAno.getFullYear(),
                tipoDispositivo: 'Web'
            }
            this.pontoService.espelho(requisicao)
            .then(resp => {
                this.pontos = resp.data.pontos;  
                this.justificativasGerais = resp.data.justificativasGerais;
                this.justificativasMarcacoes = resp.data.justificativasMarcacoes;
            })
            .catch(erro => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                }            
            });         
        },
        /**
         * 
         */
         exibirIncluirMarcacao(pontoSelecionado) {
            this.$refs.formIncluirSolicitacao
            .exibirIncluirMarcacao(pontoSelecionado, this.mesAno, this.justificativasMarcacoes);
        },
        /**
         * 
         */
        exibirJustificarPonto(pontoSelecionado) {
            this.$refs.formIncluirSolicitacao
            .exibirJustificarPonto(pontoSelecionado, this.mesAno, this.justificativasGerais);
        },
        /**
         * 
         */
        formatarData(strData) {            
            if(!strData) {
                return '';
            }
            let partesData = strData.split('-');
            return partesData[2] + '/' + partesData[1] + '/' + partesData[0];
        },
        /**
         * 
         */
         formatarDataHora(strDataHora) {
            if(!strDataHora) {
                return '';
            }
            let partesDataHora = strDataHora.split(' ');
            let partesData = partesDataHora[0].split('-');
            return partesData[2] + '/' + partesData[1] + '/' + partesData[0] + ' ' + partesDataHora[1];
        },        
        /**
         * 
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-40)+':'+(anoAtual+1);     
        }, 
        /**
         * 
         */
        logout() {
            this.limparSessao();			
            this.$router.push('/login?exp=sessao_expirada');
        }         
    },
    created() { 
        let usu = this.getUsuario(); 
        this.temIncluirMarcacao = usu.permissoes.incluirMarcacao;
        this.temJustificarPonto = usu.permissoes.justificarPonto;
        this.criarRangeData();        
        this.pontoService = new PontoService();   
        this.getEspelho();         
    },
    components: {
        SolicitacaoCelular
    }
}
</script>        
</style>